import posthog from 'posthog-js';
import { track } from '@vercel/analytics';
import { getEnvironmentData } from '../utils/environment';
import { analyticsOptOut } from '../utils/privacy';

export const trackSubmitRequest = (requestId, title, category = null) => {
  if (analyticsOptOut.hasOptedOut()) return;
  
  const eventData = {
    request_id: requestId,
    title_length: title.length,
    category: category,
    ...getEnvironmentData()
  };

  posthog.capture('submit_request', eventData);
  track('submit_request', eventData);
  
  // Add TikTok tracking
  if (typeof window !== 'undefined' && window.ttq) {
    window.ttq.track('CompleteRegistration', {
      content_name: 'app_request',
      content_type: 'product',
      content_id: requestId,
      value: 1
    });
  }
}; 